import { Avatar, DropdownMenu, Icon, IconButton, Typography } from "@/components/atoms";
import { getAssetUrl } from "@/utils";
import { DriverStatusBadge } from "../../../../common/DriverStatusBadge";
import { useProfileContext } from "../../context";

export const DriverHeader = () => {
  const { driver, setActiveModal } = useProfileContext();
  const { personal, status, rating } = driver;
  const driverName = `${personal.firstName} ${personal.lastName}`;

  const renderAvatar = () => {
    const src = getAssetUrl(driver.avatar || "", { height: 128, width: 128, fit: "cover" });
    if (driver.isFleetLeader)
      return (
        <img
          className="h-[72px] w-[72px] shrink-0 rounded-full object-cover ring-4 ring-success ring-offset-4"
          src={src}
          alt={driverName}
        />
      );

    return <Avatar size="xl" src={src} alt={driverName} />;
  };

  const renderRating = () => {
    const { jobsCompleted, rating: driverRating } = rating;
    if (jobsCompleted) {
      return (
        <div className="flex flex-row items-center gap-1.5">
          {(driverRating || driverRating === 0) && (
            <div className="flex flex-row items-center gap-x-2">
              <Icon name="Star1" className="fill-warning text-warning" />
              <Typography variant="title">{driverRating}</Typography>
            </div>
          )}
          <Typography variant="action" className="text-neutral-dark-gray">
            {`(${jobsCompleted} ${jobsCompleted === 1 ? "Job" : "Jobs"})`}
          </Typography>
        </div>
      );
    }
  };

  return (
    <div className="flex flex-row items-center gap-6">
      {renderAvatar()}
      <div className="flex w-full flex-row">
        <div className="flex flex-1 flex-col gap-1">
          <Typography variant="h3" className="flex items-center gap-2">
            {driverName}
            <DriverStatusBadge status={driver.status} />
          </Typography>
          {renderRating()}
        </div>
        <div className="flex flex-row items-center gap-3">
          <Typography variant="paragraph" className="text-neutral-dark-gray">{`Driver ID: ${driver.shareCode}`}</Typography>
          {status !== "removed" && (
            <DropdownMenu button={<IconButton isCustomIcon iconName="options" size="sm" variant="tertiary" />} position="bottom-end">
              <DropdownMenu.Item onClick={() => setActiveModal("remove-driver")}>
                <Icon name="Trash" className="mr-2.5 text-danger" size="sm" />
                <Typography variant="paragraph">Remove Driver</Typography>
              </DropdownMenu.Item>
              {status !== "suspended" ? (
                <DropdownMenu.Item onClick={() => setActiveModal("suspend-driver")}>
                  <Icon name="MinusCircle" variant="Bold" className="mr-2.5 text-danger" size="sm" />
                  <Typography variant="paragraph">Suspend Driver</Typography>
                </DropdownMenu.Item>
              ) : (
                <DropdownMenu.Item onClick={() => setActiveModal("unsuspend-driver")}>
                  <Icon name="Refresh2" className="mr-2.5" size="sm" />
                  <Typography variant="paragraph">Unsuspend Driver</Typography>
                </DropdownMenu.Item>
              )}
            </DropdownMenu>
          )}
        </div>
      </div>
    </div>
  );
};
